import { PathOptions } from "leaflet";
import { palette, hashIndex } from "./apl_pe_observatorio";

/**
 * Colore cada município pela vocação principal (`vocacao_1`), reaproveitando a
 * paleta do APL para que as duas camadas da categoria falem a mesma língua.
 *
 * Município sem vocação na planilha da ADEPE fica só com o contorno: o join da
 * camada é LEFT, então ele continua no mapa, e pintá-lo sugeriria um dado que
 * não existe.
 */
export const municipios_pe_adepe = (feature: any): PathOptions => {
  const vocacao = feature.properties?.vocacao_1;

  if (!vocacao) {
    return {
      color: "#000000",
      weight: 1,
      opacity: 0.4,
      fillOpacity: 0,
    };
  }

  return {
    color: "#000000",
    weight: 2,
    opacity: 0.8,
    fillColor: palette[hashIndex(vocacao)],
    fillOpacity: 0.6,
  };
};
